import React, { Component } from 'react'
import { Redirect } from 'react-router-dom';

import { Auth } from '../support';
import Storage from '../support/Storage';
import Loading from '../facturotopia/loading/Loading';

class ReceptoresBridge extends Component {

  state = {}

  constructor(props) {
    super(props);

    this.state = {
      restored: false,
      hint: 'Recuperando información de sesión'
    }
  }

  async componentDidMount() {
    if (!Auth.isAuthenticated()) {
      const data = await Storage.get('facturotopia');

      if (!!data) {
        Auth.setData(data);
      }
    }

    this.setState({
      restored: true
    });
  }

  render() {
    const { restored } = this.state;

    if (restored) {
      const { from } = this.props.location.state || { from: { pathname: '/ext/receptores/facturas' } };
      const redirectTo = Auth.isAuthenticated() ? from.pathname : '/ext/receptores/auth/login';

      return <Redirect to={ redirectTo } state={ from }/>;
    }

    return <Loading />;
  }
}

export default ReceptoresBridge;